import { Instagram } from 'lucide-react';
import { motion } from 'framer-motion';

const INSTAGRAM_URL = 'https://www.instagram.com/frequencyforest.au/';

const posts = [
  { src: '/images/artwork/hero-post.jpg', alt: 'Frequency Forest artwork', rotate: '-2deg' },
  { src: 'https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Festival crowd', rotate: '1.5deg' },
  { src: '/images/artwork/aria-stage.jpg', alt: 'Aria Stage lineup', rotate: '-1deg' },
  { src: 'https://images.pexels.com/photos/2422265/pexels-photo-2422265.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Camping under the stars', rotate: '2deg' },
  { src: '/images/artwork/mandala-stage.jpg', alt: 'Mandala Stage lineup', rotate: '-2.5deg' },
  { src: 'https://images.unsplash.com/photo-1502137840985-4ec07e8568bf?w=600', alt: 'Carnival ferris wheel', rotate: '1deg' },
  { src: '/images/artwork/lineup-flyer.jpg', alt: 'Full lineup flyer', rotate: '-1.5deg' },
  { src: 'https://images.pexels.com/photos/2263436/pexels-photo-2263436.jpeg?auto=compress&cs=tinysrgb&w=600', alt: 'Community gathering', rotate: '2.5deg' },
];

const Tile = ({ post }) => (
  <a
    href={INSTAGRAM_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="group relative block w-44 h-44 sm:w-56 sm:h-56 flex-shrink-0 rounded-2xl overflow-hidden border-2 border-ff-outline/20 bg-white transition-transform duration-300 hover:scale-105 hover:!rotate-0 hover:z-10"
    style={{ rotate: post.rotate }}
    aria-label="View on Instagram"
  >
    <img src={post.src} alt={post.alt} loading="lazy" className="w-full h-full object-cover" />
    <div className="absolute inset-0 bg-ff-brown/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-2">
      <Instagram className="w-7 h-7 text-white" />
      <span className="text-white text-xs font-semibold tracking-wide">@frequencyforest.au</span>
    </div>
  </a>
);

export const InstagramStrip = () => (
  <section className="py-20 sm:py-28 bg-ff-green relative overflow-hidden" data-testid="instagram-strip-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="flex items-center gap-2 mb-3">
            <span className="bg-ff-yellow rounded-full p-2">
              <Instagram className="w-4 h-4 text-ff-brown" />
            </span>
            <span className="text-ff-brown/60 text-sm uppercase tracking-widest font-semibold">On the gram</span>
          </div>
          <h2 className="font-display text-5xl sm:text-6xl text-ff-brown">Follow the Forest</h2>
        </motion.div>
        <motion.a
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-ff-yellow text-ff-brown px-6 py-3 rounded-full font-bold text-sm hover:brightness-105 transition-all self-start sm:self-auto"
          data-testid="instagram-follow-btn"
        >
          <Instagram className="w-4 h-4" />
          @frequencyforest.au
        </motion.a>
      </div>
    </div>

    {/* Marquee */}
    <div className="ig-marquee relative">
      <div className="ig-marquee-track flex items-center gap-5 py-6 w-max">
        {[...posts, ...posts].map((post, i) => (
          <Tile key={i} post={post} />
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-12 sm:w-24 bg-gradient-to-r from-ff-green to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-12 sm:w-24 bg-gradient-to-l from-ff-green to-transparent z-10" />
    </div>
  </section>
);
